import gql from "graphql-tag";

export const UpdateOrderStatus = gql`
  mutation UpdateOrderStatus($id: String!, $status: OrderStatus!) {
    editOrder(id: $id, status: $status) {
      id
    }
  }
`;

export const ExportOrders = gql`
  mutation ExportOrders(
    $id: QueryableInt
    $name: QueryableString
    $createdAt: QueryableDateTime
    $quantity: QueryableInt
    $amount: QueryableFloat
    $status: QueryableString
    $address: QueryableString
    $buyer: QueryableString
    $seller: QueryableString
    $email: QueryableString
    $cursor: String
    $limit: Int
  ) {
    exportOrders(
      order: {
        id: $id
        product: { name: $name }
        createdAt: $createdAt
        quantity: $quantity
        amount: $amount
        address: $address
        buyer: { name: $buyer }
        seller: { name: $seller }
        status: $status
        email: $email
        cursor: $cursor
        limit: $limit
      }
    ) {
      url
    }
  }
`;
